import { render } from "./App.vue?vue&type=template&id=64482bd8"
import script from "./App.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./App.vue?vue&type=script&charset=utf-8&lang=js"

import "./App.vue?vue&type=style&index=0&id=64482bd8&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__